import { Injectable, QueryList } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { ProjectCardStore } from './projectcard.store';

import { Store } from '@ngrx/store';
import * as fromStore from './../index';
import * as fromRoot from '@usimweb/state/router-store';

@Injectable({
  providedIn: 'root',
})
export class CompareService {
  constructor(
    private snackBar: MatSnackBar,
    private cardStore: ProjectCardStore,
    private store: Store<fromStore.DashboardState>
  ) {}

  public navigate(uuid: string, index: number, cards: QueryList<any>) {
    const currentCard = cards.find((_, i) => i == index);

    if (currentCard) {
      this.cardStore.getCompare$.subscribe((isCompare) => {
        currentCard!.compareActive = isCompare;
      });

      this.cardStore.addSelection({ index: index || 0, uuid: currentCard!.uuid });

      this.cardStore.getValues().subscribe((state) => {
        if (state.compare) {
          this.store.dispatch(
            new fromRoot.Go({ path: ['app/compare/' + uuid + '/' + state.uuids[0] + '/' + state.uuids[1]] })
          );
          this.cardStore.resetSelection();
        }
      });
    }
  }

  public toggle(compare: boolean, cards: QueryList<any>): string {
    this.cardStore.patchCompare(compare);

    let compareBox = '';
    if (compare) {
      this.snackBar.open('Select two simulations to compare...', 'OK', { duration: 5000 });
      cards.forEach((card) => {
        card.compareActive = true;
      });
    } else {
      cards.forEach((card) => {
        card.selectedBorder = 'none';
        card.isCompareSelected = false;
      });

      this.cardStore.resetSelection();
    }
    return compareBox;
  }
}
